import { ActivityMenuPair } from "components/selection-components/summary/activity-menu-pair";
import { t } from "i18next";
import { warn } from "logger/logger";
import { Article } from "types/article";
import { PaymentCalculationRule } from "types/payment";
import { WebRule } from "types/web-rule";

export function getPaymentCalculationTotal(
    rule: WebRule | null,
    guests: number,
    resourceArticles: Article[]
): number {
    if (!rule || !rule.paymentCalculationRule) return 0;
    switch (rule.paymentCalculationRule) {
        case PaymentCalculationRule.PaymentPerBooking:
            return rule.paymentAmount;
        case PaymentCalculationRule.PaymentPerGuest:
            return rule.paymentAmount * guests;
        case PaymentCalculationRule.PaymentPerResource:
            return rule.paymentAmount * (resourceArticles?.length || 1);
        default:
            warn(
                `getPaymentCalculationTotal: Unknown payment calculation rule ${JSON.stringify(
                    rule.paymentCalculationRule
                )}`
            );
            return rule.paymentAmount;
    }
}

export function getPaymentUnitTranslation(rule: WebRule): string {
    switch (rule.paymentCalculationRule) {
        case PaymentCalculationRule.PaymentPerBooking:
            return t("payment.unit.booking");
        case PaymentCalculationRule.PaymentPerGuest:
            return t("payment.unit.guest");
        case PaymentCalculationRule.PaymentPerResource:
            return t("payment.unit.resource");
        default:
            return t("payment.unit.guest");
    }
}

/**
 * Presents an activity for the summary with the correct quantity information
 * @param rule
 * @param activityMenyPair
 * @param guests
 * @returns
 */
export function getSummaryResourcePaymentBreakdownText(
    activityMenyPair: ActivityMenuPair,
    guests: number
) {
    switch (activityMenyPair?.paymentCalculationRule) {
        case PaymentCalculationRule.PaymentPerBooking:
            return t("activitySummary.menuItemRow", {
                name: activityMenyPair.articleGroupName,
                quantity: 1,
                price: t("currency.onlyAmount", {
                    value: activityMenyPair.resourceTotalPrice,
                    display: "symbol",
                }),
            });
        case PaymentCalculationRule.PaymentPerGuest:
            return t("activitySummary.menuGroupGuestPricemodelRow", {
                name: activityMenyPair.articleGroupName,
                quantity: guests,
                price: t("currency.onlyAmount", {
                    value: activityMenyPair.rulePaymentAmount,
                    display: "symbol",
                }),
            });
        case PaymentCalculationRule.PaymentPerResource:
            return t("activitySummary.menuItemRow", {
                name: activityMenyPair.articleGroupName,
                quantity: activityMenyPair.quantity,
                price: t("currency.onlyAmount", {
                    value: activityMenyPair.rulePaymentAmount,
                    display: "symbol",
                }),
            });
        default:
            warn(
                `getSummaryResourcePaymentBreakdownText: Unknown payment calculation rule ${JSON.stringify(activityMenyPair?.paymentCalculationRule)}`
            );
    }
}
